/**
 * Fellheimat - Geschenke und Paketschutz als eigene Warenkorbpositionen
 *
 * NEUE OFFER (22.10.2026, Theme v20)
 * Bis v19 hing die Gratis-Leine als Line-Item-Property am Geschirr und der
 * Paketschutz war eine dritte Variante des Geschirrs, weil CJ jede
 * Zusatzposition als eigenen Versand behandelt hat (Bestellung #1003). Der
 * Betreiber hat am 22.10.2026 entschieden, dass das nicht mehr gilt. Seitdem
 * sind alle Zugaben eigene Produkte, Eckdaten in snippets/fh-gift-config,
 * snippets/fh-ebook-config und snippets/fh-free-gift-config.
 *
 * SOLL-ZUSTAND DES WARENKORBS (desired)
 *   - je Geschirr eine Gratis-Leine in der passenden Farbe (Wolfsgrau -> Schwarz)
 *   - mindestens ein Geschirr -> genau ein E-Book "In 7 Tagen zur lockeren Leine"
 *   - mindestens jacketMin Jacken -> genau ein Silvester-Notfallplan
 *   - mindestens ein echtes Produkt und Paketschutz gewuenscht -> genau ein
 *     Paketschutz. Gewuenscht ist, was der Kunde zuletzt am Schalter gewaehlt
 *     hat (localStorage fh_shield = on | off), sonst die Vorauswahl.
 * Hilfsprodukte zaehlen nie als echtes Produkt.
 *
 * NUR IM BUNDLE GRATIS (23.10.2026)
 * Leine und E-Books haben Normalpreise (19,95 und 14,95). Gratis werden sie
 * ueber automatische Kaufe-X-erhalte-Y-Rabatte, nur zusammen mit Geschirr
 * bzw. 2 Jacken. Was dieses Skript einlegt, traegt die unsichtbare Property
 * _fh_auto und ist damit von selbst gekauften E-Books unterscheidbar. Nur
 * markierte Zeilen (und der Paketschutz) werden verwaltet. Ein selbst
 * gekauftes E-Book bleibt liegen, zaehlt am Warenkorb-Symbol mit und ersetzt
 * das Geschenk-E-Book (es wird dann ueber den Rabatt gratis). E-Books brauchen
 * keinen Versand und loesen deshalb keinen Paketschutz aus.
 *
 * WANN ABGEGLICHEN WIRD
 * 1. Add-to-Cart (Horizon, Mengenstaffel, Upsell): der Request wird NUR
 *    GELESEN. Vor dem Weiterreichen legt dieses Skript die fehlenden
 *    Hilfsprodukte mit einem eigenen add.js ein. Horizons Antwort rendert den
 *    Drawer danach mit allem, der Kunde sieht nie einen halben Zustand und die
 *    2,95 stehen sofort in der Summe. Kostet eine Runde von rund 0,2 s.
 * 2. Jede andere Warenkorbaenderung (Menge, Entfernen, Leeren): 250 ms nach der
 *    Antwort reconcile(). Weicht der Warenkorb vom Soll ab, wird er per add.js
 *    und update.js angeglichen und der Drawer mit Horizons Renderer neu
 *    gemorpht.
 * 3. Seitenaufruf: reconcile(), damit auch alte Warenkoerbe stimmen.
 * 4. Paketschutz-Schalter (snippets/fh-shield-line): reconcile() mit Morph.
 *
 * ALTE WARENKOERBE (aus v19 und davor)
 * cleanupLegacy() stellt "Mit Paketschutz"-Varianten auf ihre Standard-Variante
 * zurueck (Zuordnung aus fh-shield-bridge, window.FH_SHIELD_LEGACY), entfernt
 * die alten Properties "Gratis dazu" und "Paketschutz" von Geschirr und Jacke
 * und wirft eine kaeufliche Leine mit der uralten Property _fh_geschenk raus.
 *
 * ZAHL AM WARENKORB-SYMBOL
 * Horizon zaehlt jede Position. Nach jedem Abgleich setzt fixBubble() die Zahl
 * auf die echten Produkte, ohne Hilfsprodukte. Serverseitig rechnet
 * snippets/cart-bubble dasselbe.
 *
 * REIHENFOLGE DER FETCH-PATCHES
 *     fh-volume-tiers.js -> fh-cart-timer.js -> fh-free-gift.js -> fetch
 * Alle eigenen Requests laufen ueber nativeFetch und loesen weder dieses
 * Skript noch den Timer erneut aus.
 */
(function () {
  'use strict';

  if (window.__fhOfferLoaded) return;
  window.__fhOfferLoaded = true;

  var C = window.FH_OFFER || {};
  if (!C.helperIds || !C.helperIds.length) return;

  var HELPER = {};
  C.helperIds.forEach(function (id) {
    HELPER[String(id)] = true;
  });

  var DIGITAL = {};
  (C.digitalIds || []).forEach(function (id) {
    DIGITAL[String(id)] = true;
  });

  var AUTO = '_fh_auto';
  var SHIELD_ID = String(C.shieldVariantId || '');

  function autoProps() {
    var p = {};
    p[AUTO] = '1';
    return p;
  }

  var HARNESS = C.harnessVariants || {};
  var JACKET = C.jacketVariants || {};
  var LEASH = C.leashByColor || {};
  var JACKET_MIN = Number(C.jacketMin) || 2;
  var LEGACY_PROPS = C.legacyProps || [];
  var LEGACY_ON = (window.FH_SHIELD_LEGACY && window.FH_SHIELD_LEGACY.onIds) || {};
  var LEGACY_OFF = {};
  Object.keys(LEGACY_ON).forEach(function (std) {
    LEGACY_OFF[String(LEGACY_ON[std])] = std;
  });

  var COLOR_MAP = (function (raw) {
    var map = {};
    String(raw || '').split(',').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) map[parts[0].trim().toLowerCase()] = parts[1].trim();
    });
    return map;
  })(C.colorMap);

  var KEY = 'fh_shield';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);

  /* Serialisiert alle eigenen Warenkorb-Operationen. */
  var pending = Promise.resolve();
  function queue(task) {
    var run = pending.then(task, task);
    pending = run.catch(function () {});
    return run;
  }

  /* --- Wunsch Paketschutz --------------------------------------------------- */

  function stored() {
    try {
      return window.localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function store(value) {
    try {
      window.localStorage.setItem(KEY, value);
    } catch (e) {
      /* privater Modus - dann gilt je Seite die Voreinstellung */
    }
  }

  function wantShield() {
    var s = stored();
    if (s === 'on') return true;
    if (s === 'off') return false;
    return !!C.shieldPreselected;
  }

  /* --- Soll-Zustand ---------------------------------------------------------- */

  function leashVariantFor(harnessColor) {
    var color = COLOR_MAP[String(harnessColor || '').toLowerCase()] || C.fallbackColor;
    return LEASH[color] || LEASH[C.fallbackColor] || null;
  }

  /**
   * lines: [{ id: Varianten-ID, quantity: n, managed: bool }] - Warenkorb
   * und/oder hinzukommende Stuecke. Liefert { Varianten-ID: Menge } fuer alle
   * verwalteten Hilfspositionen, die im Warenkorb liegen sollen.
   */
  function desired(lines) {
    var want = {};
    var manual = {};
    var shippable = 0;
    var harness = 0;
    var jackets = 0;

    lines.forEach(function (line) {
      var id = String(line.id);
      var qty = Number(line.quantity) || 0;
      if (qty <= 0 || line.managed) return;
      if (HELPER[id]) {
        /* selbst gekauft, etwa ein E-Book */
        manual[id] = (manual[id] || 0) + qty;
        return;
      }
      if (!DIGITAL[id]) shippable += qty;

      if (Object.prototype.hasOwnProperty.call(HARNESS, id)) {
        harness += qty;
        var leash = leashVariantFor(HARNESS[id]);
        if (leash) want[leash] = (want[leash] || 0) + qty;
      }
      if (JACKET[id]) jackets += qty;
    });

    if (harness > 0 && C.ebookVariantId) want[C.ebookVariantId] = 1;
    if (jackets >= JACKET_MIN && C.silvesterVariantId) want[C.silvesterVariantId] = 1;
    if (shippable > 0 && SHIELD_ID && wantShield()) want[SHIELD_ID] = 1;

    /* Ein selbst gekauftes E-Book ersetzt das Geschenk. */
    Object.keys(manual).forEach(function (id) {
      if (want[id]) want[id] = Math.max(0, want[id] - manual[id]);
      if (!want[id]) delete want[id];
    });
    return want;
  }

  function isManaged(item) {
    var id = String(item.variant_id);
    if (!HELPER[id]) return false;
    if (id === SHIELD_ID) return true;
    return !!(item.properties && item.properties[AUTO]);
  }

  function linesOf(cart) {
    return (cart.items || []).map(function (item) {
      return { id: item.variant_id, quantity: item.quantity, managed: isManaged(item) };
    });
  }

  function helperState(cart) {
    var state = {};
    (cart.items || []).forEach(function (item) {
      var id = String(item.variant_id);
      if (!isManaged(item)) return;
      if (!state[id]) state[id] = { quantity: 0, keys: [] };
      state[id].quantity += item.quantity;
      state[id].keys.push(item.key);
    });
    return state;
  }

  function realCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return isManaged(item) ? sum : sum + item.quantity;
    }, 0);
  }

  /* --- Warenkorb ------------------------------------------------------------- */

  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function post(path, payload) {
    return nativeFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json();
    });
  }

  function sectionTargets() {
    var out = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var id = c.dataset.sectionId;
      if (!id) return;
      out.push({ id: id, mode: c.dataset.drawer !== undefined ? 'hydration' : 'full' });
    });
    return out;
  }

  /* Ersatzweg ohne Horizons Renderer (aus fh-shield.js uebernommen). */
  function replaceRaw(sections) {
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var html = sections && sections[c.dataset.sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('cart-items-component');
      if (fresh) c.innerHTML = fresh.innerHTML;
    });
  }

  function morph(sections) {
    if (!sections) return Promise.resolve();
    var targets = sectionTargets();
    return import('@theme/section-renderer')
      .then(function (m) {
        return Promise.all(
          targets.map(function (t) {
            var html = sections[t.id];
            return html ? m.morphSection(t.id, html, { mode: t.mode }) : null;
          })
        );
      })
      .catch(function (e) {
        if (window.console) console.warn('[fh-offer] morph fehlgeschlagen, Ersatzweg:', e);
        replaceRaw(sections);
      });
  }

  function fixBubble(cart) {
    if (!cart || !cart.items) return;
    var count = realCount(cart);
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      if (typeof icon.renderCartBubble !== 'function') return;
      if (icon.currentCartCount === count) return;
      icon.renderCartBubble(count, false);
    });
  }

  /* --- Alte Warenkoerbe ------------------------------------------------------ */

  function stripLegacy(props) {
    var out = {};
    var changed = false;
    Object.keys(props || {}).forEach(function (k) {
      if (LEGACY_PROPS.indexOf(k) !== -1) {
        changed = true;
        return;
      }
      out[k] = props[k];
    });
    return changed ? out : null;
  }

  /* Loest sich zum aktuellen Warenkorb auf. Nur wenn es etwas aufzuraeumen
     gab, wird der Warenkorb danach frisch geholt. */
  function cleanupLegacy(cart) {
    var adds = [];
    var removeKeys = [];
    var propFixes = [];

    (cart.items || []).forEach(function (item) {
      var id = String(item.variant_id);
      var props = item.properties || {};

      if (C.legacyLeashId && String(item.product_id) === String(C.legacyLeashId) && props._fh_geschenk) {
        removeKeys.push(item.key);
        return;
      }

      if (LEGACY_OFF[id]) {
        adds.push({ id: Number(LEGACY_OFF[id]), quantity: item.quantity, properties: stripLegacy(props) || props });
        removeKeys.push(item.key);
        return;
      }

      if (HARNESS[id] !== undefined || JACKET[id]) {
        var stripped = stripLegacy(props);
        if (stripped) propFixes.push({ variantId: id, key: item.key, quantity: item.quantity, properties: stripped });
      }
    });

    if (!adds.length && !removeKeys.length && !propFixes.length) return Promise.resolve(cart);

    var chain = Promise.resolve();
    if (adds.length) {
      chain = chain.then(function () {
        return post('/cart/add.js', { items: adds });
      });
    }
    if (removeKeys.length) {
      chain = chain.then(function () {
        var updates = {};
        removeKeys.forEach(function (k) {
          updates[k] = 0;
        });
        return post('/cart/update.js', { updates: updates });
      });
    }
    /* change.js mit Properties aendert den Zeilenschluessel. Deshalb je Zeile
       frisch aufloesen: erst ueber den alten Schluessel, sonst ueber die
       Varianten-ID einer Zeile, die noch eine alte Property traegt. */
    propFixes.forEach(function (fix) {
      chain = chain.then(function () {
        return getCart().then(function (fresh) {
          var hit = null;
          (fresh.items || []).forEach(function (item) {
            if (item.key === fix.key) hit = item;
          });
          if (!hit) {
            (fresh.items || []).forEach(function (item) {
              if (!hit && String(item.variant_id) === fix.variantId && stripLegacy(item.properties)) hit = item;
            });
          }
          if (!hit) return null;
          return post('/cart/change.js', { id: hit.key, quantity: hit.quantity, properties: stripLegacy(hit.properties) || {} });
        });
      });
    });

    return chain.then(getCart, getCart);
  }

  /* --- Abgleich -------------------------------------------------------------- */

  /**
   * Bringt die Hilfsprodukte auf den Soll-Zustand. Mit force wird der Drawer
   * auch dann neu gerendert, wenn sich nichts geaendert hat (Schalter).
   */
  function reconcile(force) {
    return getCart()
      .then(cleanupLegacy)
      .then(function (cart) {
        var want = desired(linesOf(cart));
        var have = helperState(cart);
        var adds = [];
        var updates = {};
        var changed = false;

        Object.keys(want).forEach(function (id) {
          var current = have[id] ? have[id].quantity : 0;
          if (current === want[id]) return;
          changed = true;
          if (!have[id]) {
            adds.push({ id: Number(id), quantity: want[id], properties: autoProps() });
          } else {
            /* Mehrere Zeilen derselben Variante: auf die erste zusammenlegen. */
            have[id].keys.forEach(function (key, i) {
              updates[key] = i === 0 ? want[id] : 0;
            });
          }
        });

        Object.keys(have).forEach(function (id) {
          if (want[id]) return;
          changed = true;
          have[id].keys.forEach(function (key) {
            updates[key] = 0;
          });
        });

        var targets = sectionTargets();
        var sectionIds = targets
          .map(function (t) {
            return t.id;
          })
          .join(',');

        if (!changed) {
          fixBubble(cart);
          if (!force || !sectionIds) return cart;
          return post('/cart/update.js', { updates: {}, sections: sectionIds, sections_url: window.location.pathname }).then(
            function (res) {
              return morph(res.sections).then(function () {
                return cart;
              });
            }
          );
        }

        var hasUpdates = Object.keys(updates).length > 0;
        var chain = Promise.resolve(null);

        if (adds.length) {
          chain = chain.then(function () {
            var payload = { items: adds };
            if (!hasUpdates && sectionIds) {
              payload.sections = sectionIds;
              payload.sections_url = window.location.pathname;
            }
            return post('/cart/add.js', payload);
          });
        }

        if (hasUpdates) {
          chain = chain.then(function () {
            var payload = { updates: updates };
            if (sectionIds) {
              payload.sections = sectionIds;
              payload.sections_url = window.location.pathname;
            }
            return post('/cart/update.js', payload);
          });
        }

        return chain.then(function (res) {
          return morph(res && res.sections)
            .then(getCart)
            .then(function (fresh) {
              fixBubble(fresh);
              return fresh;
            });
        });
      })
      .catch(function (e) {
        if (window.console) console.warn('[fh-offer] Abgleich fehlgeschlagen:', e);
      });
  }

  /* --- Add-to-Cart lesen ----------------------------------------------------- */

  /* Liest, welche Stuecke ein Add-Request hinzufuegt. Aendert nichts. */
  function readAdds(input, init) {
    var body = (init && init.body) || (input && input.body);
    if (!body) return null;
    var out = [];
    try {
      var isForm = typeof FormData !== 'undefined' && body instanceof FormData;
      var isParams = typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams;
      if (isForm || isParams) {
        var slots = {};
        body.forEach(function (value, key) {
          var m = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(key);
          if (!m) return;
          slots[m[1]] = slots[m[1]] || {};
          slots[m[1]][m[2]] = value;
        });
        Object.keys(slots).forEach(function (n) {
          if (slots[n].id) out.push({ id: slots[n].id, quantity: Number(slots[n].quantity) || 1 });
        });
        var top = body.get('id');
        var topQty = body.get('quantity');
        if (top && String(topQty) !== '0') out.push({ id: top, quantity: Number(topQty) || 1 });
        return out;
      }
      if (typeof body === 'string') {
        var j = JSON.parse(body);
        if (j.items && j.items.length) {
          j.items.forEach(function (item) {
            out.push({ id: item.id, quantity: Number(item.quantity) || 1 });
          });
        } else if (j.id) {
          out.push({ id: j.id, quantity: Number(j.quantity) || 1 });
        }
        return out;
      }
    } catch (e) {
      /* nicht auswertbar - dann uebernimmt reconcile() */
    }
    return null;
  }

  /* Legt vor dem eigentlichen Add die fehlenden Hilfsprodukte ein. Wirft nie:
     im Zweifel geht der Kunden-Request unveraendert raus und reconcile()
     zieht nach. */
  function prepareAdd(adds) {
    return getCart()
      .then(cleanupLegacy)
      .then(function (cart) {
        var want = desired(linesOf(cart).concat(adds));
        var have = helperState(cart);
        var items = [];
        Object.keys(want).forEach(function (id) {
          var missing = want[id] - (have[id] ? have[id].quantity : 0);
          if (missing > 0) items.push({ id: Number(id), quantity: missing, properties: autoProps() });
        });
        if (!items.length) return null;
        return post('/cart/add.js', { items: items });
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleReconcile() {
    setTimeout(function () {
      queue(function () {
        return reconcile(false);
      });
    }, 250);
  }

  /* --- fetch-Patch ----------------------------------------------------------- */

  window.fetch = function (input, init) {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (CART_ADD.test(url)) {
      var real = readAdds(input, init) || [];
      if (real.length) {
        var run = queue(function () {
          return prepareAdd(real);
        }).then(function () {
          return nativeFetch.apply(null, args);
        });
        run.then(scheduleReconcile, function () {});
        return run;
      }
    }

    var promise = nativeFetch.apply(null, args);
    if (CART_WRITE.test(url)) promise.then(scheduleReconcile, function () {});
    return promise;
  };

  /* --- Paketschutz-Schalter ---------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-fh-shield-toggle')) return;

    var on = input.checked;
    var before = stored();
    store(on ? 'on' : 'off');

    var root = input.closest('[data-fh-shield]');
    if (root) root.classList.add('is-busy');

    queue(function () {
      return reconcile(true);
    })
      .catch(function () {
        input.checked = !on;
        if (before) store(before);
      })
      .then(function () {
        if (root) root.classList.remove('is-busy');
      });
  });

  /* --- Klebender Summenblock im Drawer ----------------------------------------- *
   * Horizon (assets/cart-drawer.js, #updateStickyState) setzt am Dialog
   * cart-summary-sticky="false", wenn beim Messen kein Summenblock da ist oder
   * er hoeher ist als die Haelfte des Drawers. Beim Laden mit leerem Warenkorb
   * ist er nie da, und beim automatischen Oeffnen nach dem Add-to-Cart misst
   * Horizon mitten in Umbau und Animation. Folge (Meldung Jasper 23.10.2026):
   * Summe und Kasse-Knopf standen am Listenende statt fest unten. Hier wird mit
   * derselben Regel nachgemessen, sobald sich der Drawer aendert oder oeffnet. */

  function fixSticky() {
    document.querySelectorAll('cart-drawer-component').forEach(function (comp) {
      var dialog = comp.closest('dialog');
      if (!dialog) return;

      /* Leer-Markierung am Rahmen mit dem Inhalt abgleichen. Horizon setzt
         cart-drawer--empty nur beim Seitenaufruf und tauscht beim ersten
         Add-to-Cart nur den Inhalt aus. Die stehengebliebene Klasse machte
         den automatisch geoeffneten Drawer ein paar Pixel zu hoch, Horizons
         Scroll-Hinweis blendete dann Kasse-Knopf und Vertrauenszeile aus
         (Meldung Jasper 23.10.2026). Mit dem Abgleich ist der Zustand
         derselbe wie beim manuellen Oeffnen. */
      var changed = false;
      var inner = dialog.querySelector('.cart-drawer__inner');
      if (inner) {
        var empty = !dialog.querySelector('.cart-form');
        if (inner.classList.contains('cart-drawer--empty') !== empty) {
          inner.classList.toggle('cart-drawer--empty', empty);
          changed = true;
        }
      }

      var summary = dialog.querySelector('.cart-drawer__summary');
      if (!summary) return;
      var drawerHeight = dialog.getBoundingClientRect().height;
      if (drawerHeight < 200) return; /* geschlossen oder mitten in der Animation */
      var ratio = summary.getBoundingClientRect().height / drawerHeight;
      var want = ratio > 0.5 ? 'false' : 'true';
      if (dialog.getAttribute('cart-summary-sticky') !== want) {
        dialog.setAttribute('cart-summary-sticky', want);
        changed = true;
      }
      /* Scroll-Hinweise (scroll-hint) neu ausrichten lassen, nur nach einer
         echten Aenderung, sonst droht eine Schleife ueber Resize-Logik. */
      if (changed) window.dispatchEvent(new Event('resize'));
    });
  }

  var stickyTimer = null;
  function scheduleSticky() {
    clearTimeout(stickyTimer);
    stickyTimer = setTimeout(function () {
      requestAnimationFrame(fixSticky);
    }, 60);
  }

  function watchDrawer() {
    if (typeof MutationObserver === 'undefined') return;
    document.querySelectorAll('cart-drawer-component').forEach(function (comp) {
      var dialog = comp.closest('dialog');
      if (!dialog || dialog.__fhSticky) return;
      dialog.__fhSticky = true;
      /* Inhalt ausgetauscht (Add-to-Cart, Morph) oder Dialog geoeffnet */
      /* Auch wenn Horizon das Attribut selbst wieder setzt. Geschrieben wird
         nur bei abweichendem Wert, eine Schleife entsteht also nicht. */
      new MutationObserver(scheduleSticky).observe(dialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'cart-summary-sticky'] });
      /* Groesse aendert sich auch nach der Oeffnungsanimation und beim Drehen */
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(scheduleSticky).observe(dialog);
      /* Horizon misst selbst kurz nach dem Oeffnen, danach noch einmal nachziehen */
      dialog.addEventListener('transitionend', scheduleSticky);
      dialog.addEventListener('animationend', scheduleSticky);
    });
  }

  /* --- Start ------------------------------------------------------------------- */

  function boot() {
    watchDrawer();
    queue(function () {
      return reconcile(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
